import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Typography, withStyles } from "@material-ui/core";

const styles = theme => ({
  main: {
    backgroundColor: '#F8F5F2',
    color: '#b08f6e',
    padding: theme.spacing(1),
  }
});

function HighlighedInformation(props) {
  const { className, children, classes } = props;
  return (
    <div className={classNames(classes.main, className ? className : null)}>
      <Typography variant="body2">{children}</Typography>
    </div>
  );
}

HighlighedInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]).isRequired,
  className: PropTypes.string
};

export default withStyles(styles, { withTheme: true })(HighlighedInformation);
